import * as GLOBAL_VARS from 'tools/environments';

const PUBLIC_TURNSTILE_SITE_KEY =
	process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY || '';

const environments = {
	...GLOBAL_VARS,
	PUBLIC_TURNSTILE_SITE_KEY,
};

export default environments;
